/**
 * The old bundle payment plan model.
 * Some users already have this bundle and are able to prolong it.
 * The id is same on both staging and production.
 */
export const PACKAGE_BUNDLE_ID = '0a5330a5-d420-417e-a99f-fd293ac65eeb';

export const ANKR_STRIPE_ACCOUNT_LINK =
  'https://billing.stripe.com/p/login/cNi28r0Yg3jW7Pb3h4eAg00';
